/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeAUpIcon16Light } from './ArrowShapeAUpIcon16Light';
import { ArrowShapeAUpIcon16Regular } from './ArrowShapeAUpIcon16Regular';
import { ArrowShapeAUpIcon16Solid } from './ArrowShapeAUpIcon16Solid';
import { ArrowShapeAUpIcon20Light } from './ArrowShapeAUpIcon20Light';
import { ArrowShapeAUpIcon20Regular } from './ArrowShapeAUpIcon20Regular';
import { ArrowShapeAUpIcon20Solid } from './ArrowShapeAUpIcon20Solid';
import { ArrowShapeAUpIcon24Regular } from './ArrowShapeAUpIcon24Regular';
import { ArrowShapeAUpIcon24Solid } from './ArrowShapeAUpIcon24Solid';
import { ArrowShapeAUpIcon32Regular } from './ArrowShapeAUpIcon32Regular';
import { ArrowShapeAUpIcon64Regular } from './ArrowShapeAUpIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeAUpIcon16Light,
        regular: ArrowShapeAUpIcon16Regular,
        solid: ArrowShapeAUpIcon16Solid,
    },
    20: {
        light: ArrowShapeAUpIcon20Light,
        regular: ArrowShapeAUpIcon20Regular,
        solid: ArrowShapeAUpIcon20Solid,
    },
    24: {
        regular: ArrowShapeAUpIcon24Regular,
        solid: ArrowShapeAUpIcon24Solid,
    },
    32: {
        regular: ArrowShapeAUpIcon32Regular,
    },
    64: {
        regular: ArrowShapeAUpIcon64Regular,
    },
};
export var ArrowShapeAUpIcon = forwardRef('ArrowShapeAUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
